'use client'

import { LoaderCircle } from 'lucide-react'
import { useLogoutFlow } from '@/lib/commerce/hooks'

export default function Logout() {
  useLogoutFlow()
  return (
    <div className="flex flex-col items-center text-center gap-4">
      <LoaderCircle className="size-8 text-foreground animate-spin" />
      <h1 className="text-[28px] sm:text-[32px] font-bold font-gilroy tracking-[-0.025em] text-foreground">Гарж байна</h1>
      <p className="text-[14px] text-foreground/60">Таныг системээс гаргаж байна. Түр хүлээнэ үү.</p>
    </div>
  )
}
